const VERIFY_CODE = 'VerifyCode';
const VERIFY_CODE_RESEARCH = 'VerifyCodeForResearch';
const PROCESS_GET_SERVICE_URL_GIZMO_REACT = 'Process_GetServiceUrl@GIZMO_REACT';
const VERIFY_CAPTCHA = 'VerifyCaptcha_Process';
const VERIFY_EMAIL = 'VerifyEmailForAccess';

export { 
  VERIFY_CODE, 
  VERIFY_CODE_RESEARCH,
  PROCESS_GET_SERVICE_URL_GIZMO_REACT,
  VERIFY_CAPTCHA,
  VERIFY_EMAIL
}